const formatDate = (date: string) =>
  new Date(date).toLocaleDateString("en-US", {
    month: "short",
    year: "numeric",
  });

const toText = (html: string) => {
  const tag = document.createElement("div");
  tag.innerHTML = html;
  return tag.innerText;
};

const Article = ({
  article,
}: {
  article: {
    title: string;
    categories: string[];
    link: string;
    pubDate: string;
    description: string;
  };
}) => {
  return (
    <div className="entry">
      <a
        className="entry-link"
        href={article.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        {article.title} ↗
      </a>
      <p className="entry-meta">{formatDate(article.pubDate)}</p>
      <p className="entry-desc">{toText(article.description).substring(0, 250)}…</p>
    </div>
  );
};

export default Article;
